import React from 'react';
import WhyChooseUs from '../components/Whyus/WhyChooseUs';
import WhyCard_one from '../components/Whyus/WhyCard_one';
import TravelFeatures from '../components/Whyus/TravelFeatures';
import Footer from '../components/Footer';
import Whycard_two from '../components/Whyus/Whycard_two';
import WhyCard_three from '../components/Whyus/WhyCard_three';

function Why() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '50px',
				marginTop: '50px',
			}}
		>
			<WhyChooseUs />
			<WhyCard_one />
			<Whycard_two />
			<TravelFeatures />
			<WhyCard_three />
			<Footer />
		</div>
	);
}

export default Why;
